var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-w-full md:tw-w-1/2"},[_c('div',{staticClass:"tw-text-left tw-h-full tw-text-[1.5rem] md:tw-text-[2rem] tw-font-semibold tw-mt-[15px] md:tw-mt-[30px] tw-ml-[10px] md:tw-ml-[20px]",staticStyle:{"color":"var(--text-bold)"}},[_c('div',{staticClass:"tw-w-full tw-px-[15px] md:tw-px-5"},[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }